export const featureFlags = {
  colorPalette: "color-palette",
  diffSummary: "diff-summary",
  documentSearch: "document-search",
  genestaSections: "genesta-sections",
  halloweenTheme: "halloween-theme",
  legalEntities: "legal-entities-for-if-demo-sept-25",
  officeOnlinePreview: "office-online-preview",
  referenceNumber: "reference-number",
  spMirroring: "sp-mirroring",
  translations: "download-translation",
  workflowTemplates: "workflow-templates",
  wopitest: "wopitest",
  bulk: "bulk",
  pinnedDocuments: "pinned-documents",
} as const;
